import React, {useState} from "react";
import {matchPath, Route} from "react-router-dom";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import Select, {SelectOption} from "@amzn/meridian/select"
import Text from "@amzn/meridian/text"
import Box from "@amzn/meridian/box";
import escapeRegExp from "lodash/escapeRegExp";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";

/**
 * Custom hook that checks which route matches the current location
 * and returns its name in the object
 * @param routes
 * @param location
 * @returns Object
 */
const useCurrentRoute = (routes, location) => {
    const currentPath = location.pathname;
    const {name} = routes.find(route => !!(matchPath(currentPath, {
        path: route.path
    }))) || {};
    return {name: name};
}

/**
 * Returns Route components from a list of routes
 * @param routes
 * @returns JSX.Element
 */
export const NavigationRoutes = ({routes}) => {
    return (
        routes.map(({path, component}) =>
            (<Route key={path} path={path} component={component}/>)
        )
    )
}

/**
 * Component that handles the tab UI and changes
 * @returns JSX.Element
 * @param props
 * @param intl
 */
const SelectLayout = (props) => {
    const [state, setState] = useState(useCurrentRoute(props.routes, props.location));
    const {formatMessage} = props.intl;
    const onSelectChange = (selectedTab) => {
        props.routes.forEach(({name, path}) => {
            if (name === selectedTab) {
                setState({name: name});
                props.history.push(path);
            }
        })
    };
    const [searchQuery, setSearchQuery] = useState()
    // Here we filter out options by creating an escaped regular expression
    // out of the search query and test it against each option label
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedOptions = props.routes.filter(
        option => !searchQuery || searchRegExp.test(option.name)
    )

    return (
        <Box type="fill" spacingInset="medium">
            <Row>
                <Text>
                    <FormattedMessage id="deviceManagement.filters" defaultMessage="Select Device Type"/>
                </Text>
                &nbsp;&nbsp;&nbsp;
                <Select value={state.name}
                        onChange={onSelectChange}
                        placeholder={formatMessage({id: "deviceManagement.tag"})}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        width={200}>
                    {
                        matchedOptions.map(deviceType =>
                            (<SelectOption key={deviceType.name} value={deviceType.name} label={deviceType.name}>
                            </SelectOption>)
                        )
                    }
                    {!matchedOptions.length ? (
                        // If there are no matched options, we display a message to our
                        // users saying their query returned no results
                        <Column alignmentVertical="center" spacing="300" spacingInset="600">
                            <Text alignment="center">
                                <FormattedMessage id="deviceManagement.noresults" defaultMessage="No Results"/>
                            </Text>
                        </Column>
                    ) : null}
                </Select>
            </Row>
        </Box>
    )
}

SelectLayout.propTypes = {
    intl: intlShape.isRequired
}

export default injectIntl(SelectLayout)



// WEBPACK FOOTER //
// ./src/components/util/SelectLayout.js